import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useStore, useTheme } from "@/comn/hooks";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils";
import { Link, useNavigate } from "react-router-dom";
import { APIS, SF_CO_TP_SRCH, SG_CO_TP_LIST, URLS } from "@/tra/tancis/ptli/ptl/cotpauth/service/PtliCoTpService";
import dayjs from "dayjs";

/*
 * Custom Code Auth
 * !== 세관 사용자 권한 이력 목록 ==!
 */
export const PTLI1008008Q = (): JSX.Element => {
    const { pgeUid } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const modal = useModal();
    const { theme } = useTheme();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const [load, setLoad] = useState(false);
    const navigate = useNavigate();

    const form = {
        form_coTpSrch: useForm({ defaultSchema: SF_CO_TP_SRCH }),
    };

    const grid = {
        coTpAuthList: useGrid({
            defaultSchema: SG_CO_TP_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getCoTpAuthList: useFetch({
            api: (page = grid.coTpAuthList.page, size = grid.coTpAuthList.size) =>
                APIS.getCoTpAuthList(form.form_coTpSrch.getValues(), page, size),
            enabled: form.form_coTpSrch.isSubmitted,
            key: [grid.coTpAuthList.page, grid.coTpAuthList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    ...pgeStore,
                    form: form.form_coTpSrch.getValues(),
                    page: grid.coTpAuthList.page,
                    size: grid.coTpAuthList.size,
                });
            },
            onError: () => modal.openModal({ content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        deleteCoTpAuth: useFetch({
            api: (dtoList: any[]) => APIS.deleteCoTpAuth(dtoList),
            key: ["delete-co-tp-auth"],
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00061" });
                fetch.getCoTpAuthList.fetch();
            },
            onError: () => modal.openModal({ content: "msg.com.00025" }),
        }),
    };

    const render = {
        coTpAuthList: {
            cell: {
                authId: (props: any) => {
                    const { value, rowValues } = props;
                    return (
                        <Link
                            to={`${URLS.ptli1008012q}/${rowValues.authId}`}
                            state={{
                                formData: form.form_coTpSrch.getValues(),
                                rowData: rowValues,
                            }}
                        >
                            {value}
                        </Link>
                    );
                },
            },
        },
    };

    const handler = {
        onSrchClick: form.form_coTpSrch.handleSubmit(() => fetch.getCoTpAuthList.fetch()),
        onClear: () => {
            form.form_coTpSrch.clearValues();
            grid.coTpAuthList.getData().length > 0 && grid.coTpAuthList.clearData();
        },

        onGridDelBtnClick: () => {
            const checkedRows = grid.coTpAuthList.getChecked();
            const formValue = form.form_coTpSrch.getValues();

            if (checkedRows.length === 0) {
                modal.openModal({ content: "msg.com.00157" });
                return;
            }

            const dtoList = checkedRows.map((row) => ({
                authId: row.authId,
                coTpCd: formValue.coTpCd,
            }));

            modal.openModal({
                content: "msg.ptl.00832",
                onConfirm: () => {
                    fetch.deleteCoTpAuth.fetch(dtoList);
                },
            });
        },
    };

    useEffect(() => {
        pgeStore?.form && form.form_coTpSrch.setValues(pgeStore.form);
        pgeStore?.form && handler.onSrchClick();
    }, [theme]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.form_coTpSrch.schema.coTpCd} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={handler.onClear} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onSrchClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"T_CO_TP_AUTH_LIST"} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role="delete" onClick={handler.onGridDelBtnClick} />
                        </Layout.Right>
                    </Layout>
                    <Grid
                        {...grid.coTpAuthList.grid}
                        data={fetch.getCoTpAuthList.data?.coTpAuthList}
                        render={render.coTpAuthList}
                    />
                </Group.Body>
            </Group>
            <Layout.Left>
                <Layout.Button
                    role={"new"}
                    onClick={() => {
                        navigate(URLS.ptli1008013s);
                    }}
                >
                    {t("B_NEW_$0", { 0: "" })}
                </Layout.Button>
            </Layout.Left>
        </Page>
    );
};
